export enum RawStreamStatusEnum {
  OPEN = 0,
  COMPLETED = 1,
  CANCELED = 16,
  CANCELED_COMPLETED = 17,
}

export interface EventStreamConfig {
  amount_per_epoch: string;
  cancelable: boolean;
  cliff: string;
  creator: string;
  epoch_interval: string;
  metadata: string;
  recipient: string;
  time_start: string;
  total_epoch: string;
}

export interface EventStreamStatus {
  epoch_canceled: string;
  epoch_claimed: string;
  status: RawStreamStatusEnum;
}

export interface EventCreateStream {
  id: string;
  balance: string;
  coin: string;
  config: EventStreamConfig;
  status: EventStreamStatus;
}
